import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link
import clubList1 from "../assets/images/club-list1.svg";
import clubList2 from "../assets/images/club-list2.svg";
import clubList3 from "../assets/images/club-list3.svg";
import { BiSolidCalendarEvent } from "react-icons/bi";
import { FaSquarePollHorizontal } from "react-icons/fa6";

const clubs = [
  {
    id: 1,
    username: "Pulp Music Club of New York",
    member: "790",
    profilePic: clubList1,
    post: "860",
    activeEvents: "5",
    date: "2025-01-07T19:00:00",
    category: "Soft Music",
    privacy: "Public",
    description: "Pulp, the cocktail bar at The Park, Kolkata epitomizes the glamour and the style of the 60s. The highlight of the place is its spatial simplicity!!",
  },
  {
    id: 2,
    username: "Rock Music Club of California",
    member: "680",
    profilePic: clubList2,
    post: "760",
    activeEvents: "3",
    date: "2025-02-07T19:00:00",
    category: "Rock Music",
    privacy: "Public",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    id: 3,
    username: "Pizza Lovers",
    member: "590",
    profilePic: clubList3,
    post: "660",
    activeEvents: "2",
    date: "2025-01-14T19:00:00",
    category: "Food Festival",
    privacy: "Privet",
    description: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
  },
  {
    id: 4,
    username: "Pulp Music Club",
    member: "750",
    profilePic: clubList1,
    post: "860",
    activeEvents: "5",
    date: "2025-03-08T19:00:00",
    category: "Soft Music",
    privacy: "Public",
    description: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.",
  },
  {
    id: 5,
    username: "Rock Music Club of California",
    member: "680",
    profilePic: clubList2,
    post: "760",
    activeEvents: "3",
    date: "2025-02-15T19:00:00",
    category: "Rock Music",
    privacy: "Privet",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    id: 6,
    username: "Pizza Lovers",
    member: "590",
    profilePic: clubList3,
    post: "660",
    activeEvents: "2",
    date: "2025-03-18T19:00:00",
    category: "Food Festival",
    privacy: "Public",
    description: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
  }
];

const Club = ({ club }) => {
  return (
    <Link 
      to={`/clubs/${club.id}`} 
      state={{ club }}  // Passing data via React Router state
      className="publication-card publication-card-ancher"
    >
      <div className="left-section">
        <div className="publication-logo">
          <img src={club.profilePic} alt={club.username} />
        </div>
        <div className="publication-info">
          <h4>{club.username}</h4>
          <p className="info-state">{club.member} members</p>
          <p className="info-state"><FaSquarePollHorizontal /> {club.post} Posts</p>
          <p className="info-state"><BiSolidCalendarEvent /> {club.activeEvents} Active events</p>
        </div>
      </div>
    </Link>
  );
};

const ClubList = () => {
  const [visible, setVisible] = useState(4);

  const handleViewMore = () => {
    setVisible((prev) => prev + 4);
  };

  return (
    <div className="newsportal-wrapper clubs">
      {clubs.slice(0, visible).map((club) => (
        <Club key={club.id} club={club} />
      ))}

      {visible < clubs.length && (
        <button className="view-more-btn" onClick={handleViewMore}>
          View More
        </button>
      )}
    </div>
  );
};

export default ClubList;
